import { sendEvent } from 'constants/mixpanelHelper';
import { PARTIAL_PUBLISH_EVENTS } from 'constants/trackingEvents';

export const sendPPSelectAllEmployeesEvent = ({
  eventName = PARTIAL_PUBLISH_EVENTS.SELECT_ALL_EMPLOYEES,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendPPSelectCurrentPageEmployeesEvent = ({
  eventName = PARTIAL_PUBLISH_EVENTS.SELECT_CURRENT_PAGE_EMPLOYEES,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendPPCheckboxSelectionEvent = ({
  eventName = PARTIAL_PUBLISH_EVENTS.CHECKBOX_SELECTION,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendPPClearSelectionEvent = ({
  eventName = PARTIAL_PUBLISH_EVENTS.CLEAR_SELECTION,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendPPShareResultsButtonEvent = ({
  eventName = PARTIAL_PUBLISH_EVENTS.SHARE_RESULTS_BUTTON,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendPPNoActionExpansionEvent = ({
  eventName = PARTIAL_PUBLISH_EVENTS.NO_ACTION_EXPANSION,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendPPSearchInNoActionEvent = ({
  eventName = PARTIAL_PUBLISH_EVENTS.SEARCH_IN_NO_ACTION,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendPPShareResultsKBaseEvent = ({
  eventName = PARTIAL_PUBLISH_EVENTS.SHARE_RESULTS_K_BASE,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendPPSwitchPublishOptionsEvent = ({
  eventName = PARTIAL_PUBLISH_EVENTS.SWITCH_PUBLISH_OPTIONS,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendPPCancelFirstScreenEvent = ({
  eventName = PARTIAL_PUBLISH_EVENTS.CANCEL_FIRST_SCREEN,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendPPNextFirstScreenEvent = ({
  eventName = PARTIAL_PUBLISH_EVENTS.NEXT_FIRST_SCREEN,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendPPConfirmationCheckboxEvent = ({
  eventName = PARTIAL_PUBLISH_EVENTS.CONFIRMATION_CHECKBOX,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendPPConfirmationCancelEvent = ({
  eventName = PARTIAL_PUBLISH_EVENTS.CONFIRMATION_CANCEL,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};
